import { render, staticRenderFns } from "./forgetSecond.vue?vue&type=template&id=37be9cc8&"
import script from "./forgetSecond.vue?vue&type=script&lang=js&"
export * from "./forgetSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports